import { useState } from "react";
import { ChevronDown, Check, X } from "lucide-react";
import useImageUrl from "../../../../../CustomHooks/useImageUrl";

const VehicleCylinderConditions = ({ data, handleImageView }) => {
  const [open, setOpen] = useState(false);
  const { getImageUrl } = useImageUrl();

  return (
    <>
      <div
        className="cy-condition-toggle "
        onClick={() => setOpen((prev) => !prev)}
      >
        <h4 className="text-dark-blue font-figtreeMedium">
          Cylinder Conditions
        </h4>
        <ChevronDown color="#021472" />
      </div>
      {open && (
        <div className="cy-vehicle-history-dialogCardBlueBox text-sm">
          {cylinderChecks.map(({ label, key }, index) => (
            <div key={key} className="flex justify-between row-b-line">
              <p>{label}</p>
              {data[key] ? <Check color="green" /> : <X color="red" />}
            </div>
          ))}
          <div className="mt-1">
            {data.pictureList ? (
              <>
                {" "}
                <h4 className="cy-history-dialogH4 pt-3">Cylinder Photo</h4>
                <img
                  src={getImageUrl(data.pictureList[0])}
                  alt="cylinder"
                  className="border p-1 rounded-md shadow-100 max-md:w-20 bg-white cursor-pointer"
                  width={100}
                  height={100}
                  onClick={() =>
                    handleImageView(getImageUrl(data.pictureList[0]))
                  }
                />
              </>
            ) : (
              <p className="text-gray-500 text-sm">No Photo</p>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default VehicleCylinderConditions;

const cylinderChecks = [
  { label: "Gas In Cylinder", key: "gasInCylinder" },
  { label: "Water In Cylinder", key: "waterInCylinder" },
  { label: "Cap On Cylinder", key: "capOnCylinder" },
  { label: "Valve Damaged", key: "valveDamaged" },
  { label: "Paint Condition", key: "paintCondition" },
];
